import { render, staticRenderFns } from "./Tab3LinkEl.vue?vue&type=template&id=739b6c19&scoped=true&"
import script from "./Tab3LinkEl.vue?vue&type=script&lang=ts&"
export * from "./Tab3LinkEl.vue?vue&type=script&lang=ts&"
import style0 from "./Tab3LinkEl.vue?vue&type=style&index=0&id=739b6c19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739b6c19",
  null
  
)

export default component.exports